var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-logo-wrapper"}},[_c('router-link',{attrs:{"to":"/","title":"Главная"},nativeOn:{"click":function($event){return _vm.$emit('hide-main-navigation')}}},[_c('svg-sprite-icon',{staticClass:"logo",attrs:{"src":'logo-mini'}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cce065a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-header/navigation-main/NavigationMainLogoButton.vue
// module id = null
// module chunks = 